module.exports = __webpack_public_path__ + "media/images/flags/16/NATO-79e526edb9c98ffd6344636f3d400454.png";